/*

Library imports from external API's

*/
import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// util imports from external API
import _ from "underscore";

//Home brewed Components
import ModalDeleteAssay from "../../Common/ModalComponents/ModalDeleteAssay.jsx";

// Misc
import { DELETE_ASSAY_MODAL} from "../../../actions/assays.js"; // dispatch constants for modals


/*
  Component: DeleteFromMyAssayButton
  Usage: For Deleting assay from My Assay List
*/
class DeleteFromMyAssayButton extends React.Component {
  constructor(props) {
    super(props);
  }
  /*
   * Dispatch the delete action when the button is clicked
   * The `rowCreatedAt`, `assayDesignId` are used as keys to
   * get specific assay's detail from list of assays in state.
   * This data will be passed to the delete modal.
   */

  dispatchDeleteActionOnButtonClick(uniqueRowId) {
    const { actions } = this.props;
    if (uniqueRowId) {
      actions.setAssayModalType(
        DELETE_ASSAY_MODAL,
        uniqueRowId
      );
    }
  }

  render() {
    const { uniqueRowId, actions } = this.props;
    const DeleteButton = () => (
      <button
        onClick={(e) =>
          {this.dispatchDeleteActionOnButtonClick(uniqueRowId)}
        }
        type="button"
        className="close btn-delete"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    );
    return (
      <>
        <DeleteButton />
        <br />
        <ModalDeleteAssay
          actions={actions}
          uniqueRowId={uniqueRowId}
        />
      </>
    );
  }
}

export default DeleteFromMyAssayButton = DeleteFromMyAssayButton;
